import React from 'react';
import { withStyles, Grid } from '@material-ui/core';

import GameTopPanel from './gameTopPanel';
import FooterPanel from './gameFooterPanel.tsx';

const styles = {
    // Full-height flex column so the footer sits at the bottom even with an empty body.
    page: {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        background: "#F2F2F2",
    },
    body: {
        flex: "1 0 auto",
        padding: "40px 8%",
    },
    header: {
        fontFamily: "Montserrat, arial, sans-serif",
        fontWeight: "bold",
        fontSize: "2rem",
        color: "#4F4F4F",
        margin: "0 0 24px 0",
    },
};

// Legal page scaffold: top bar + page header + body content + footer.
class LegalPage extends React.Component {
    render() {
        const { classes, title, children } = this.props;
        return (
            <div className={classes.page}>
                <GameTopPanel />
                <Grid container className={classes.body}>
                    <Grid item xs={12}>
                        <h1 className={classes.header}>{title}</h1>
                        {children}
                    </Grid>
                </Grid>
                <FooterPanel />
            </div>
        );
    }
}

export default withStyles(styles)(LegalPage);
